import styled from "styled-components";
import { tablet, mobile, laptop } from "../../responsive";

export const Container = styled.div`
  width: 100%;
  margin: auto;
`;
export const PhaseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 8px;
  transition: all 0.7s ease-in-out;
  ${laptop({
    width: "80%",
    textAlign: "center",
  })}
  ${tablet({
    width: "80%",
    textAlign: "center",
  })}
  ${mobile({
    width: "80%",
    textAlign: "center",
  })}
`;

export const SliderContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding-bottom: 10px;
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(
      180deg,
      rgba(15, 23, 42, 0.35) 0%,
      rgba(15, 23, 42, 0.62) 55%,
      rgba(15, 23, 42, 0.78) 100%
    ),
    url(${(props) => props.iurl});
  background-size: cover;
  background-position: center;
  &:hover ${PhaseContainer} {
    transform: scale(1.04);
  }
  ${tablet({
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  })}
  ${mobile({
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    minHeight: "100svh",
  })}
`;
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Phase = styled.p`
  font-size: 65px;
  color: white;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
  margin-bottom: 18px;
  ${laptop({
    fontSize: "40px",
  })}
  ${tablet({
    fontSize: "28px",
  })}
  ${mobile({
    fontSize: "24px",
  })}
`;

export const Button = styled.button`
  background-color: #25d366;
  border: 1px solid #25d366;
  padding: 12px 22px;
  border-radius: 999px;
  color: white;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.04em;
  transition: all 0.35s ease-in-out;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(37, 211, 102, 0.28);
  &:hover {
    background-color: #1ebe57;
    border-color: #1ebe57;
    color: white;
    transform: translateY(-1px);
  }
`;

export const Arrow = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: ${(props) => (props.dir === "left" ? "10px" : "unset")};
  right: ${(props) => (props.dir === "right" ? "10px" : "unset")};
  cursor: pointer;
  opacity: 0.85;
  z-index: 2;
  transition: opacity 0.2s ease, background 0.2s ease;
  &:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.28);
  }
  &:before {
    font-size: 30px;
  }
`;
